import React from "react";
import Form from "../form";
import { PageWidth, Button } from "../components";
import { useSettings } from "../hooks";

export function Hero() {
  const { description, phoneNumber = "", heroText } = useSettings();

  return (
    <div className="mv4">
      <PageWidth className="overflow-hidden">
        <div className="flex-l items-center-l nl4-l nr4-l">
          <div className="ph4-l w-50-l white ttu fw7 tc">
            <div className="f1 mb4 lh-solid">{description}</div>

            {phoneNumber && (
              <div className="f2 flex items-center justify-center">
                <Button
                  className="phone-number db"
                  href={`tel:+1${phoneNumber.replace(/\D+/g, "")}`}
                >
                  {phoneNumber}
                </Button>
              </div>
            )}

            {heroText && <div className="mt4 f3 lh-copy">{heroText}</div>}
          </div>
          <div className="ph4-l w-50-l mt3 mt0-l">
            <Form className="mw6 center" />
          </div>
        </div>
      </PageWidth>
    </div>
  );
}

export default Hero;
